import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateStringWithAt'
})
export class DateStringWithAtPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(date: string | null): string {
    if (!date) return '';
    const d = new Date(date);
    const formattedDate = new Intl.DateTimeFormat(this.locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(d);

    const formattedTime = new Intl.DateTimeFormat(this.locale, {
      hour: 'numeric',
      minute: 'numeric'
    }).format(d);

    const localizedAt = $localize`:separator between date and time:at`;
    return `${formattedDate} ${localizedAt} ${formattedTime}`;
  }
}
